module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="player-choose-position-modal">\n	<header class="player-choose-position-modal-header">\n		<p>\n			'+
((__t=( _.size(player.positions) > 1 ? 'This is a Dual Position player. ' : '' ))==null?'':_.escape(__t))+
'\n			Which position would you \u2028like to add them to in your team?\n		</p>\n	</header>\n	<section class="player-choose-position-modal-info">\n		<figure>\n			<picture>\n				<source srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 50, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n				<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 50 }) ))==null?'':_.escape(__t))+
'" alt="">\n			</picture>\n		</figure>\n		<div class="player-info">\n			<div class="player-name">\n				<i class="player-status '+
((__t=( status ))==null?'':_.escape(__t))+
'"></i>\n				<span>'+
((__t=( player.first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( player.last_name ))==null?'':_.escape(__t))+
'</span>\n			</div>\n			<div class="player-positions">\n				<span>'+
((__t=( player.position_names.join(' , ') ))==null?'':_.escape(__t))+
'</span>\n				<span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>\n				<span>'+
((__t=( _.currencyFormat(player.cost, '') ))==null?'':_.escape(__t))+
'</span>\n			</div>\n		</div>\n	</section>\n	<footer class="player-choose-position-modal-footer">\n		<div class="player-choose-position-modal-footer-cancel">\n			<h4>Select Player Position</h4>\n			<a class="js-close">Cancel</a>\n		</div>\n		<div class="player-choose-position-modal-footer-btns">\n			';
 _.each(available_positions, function(key){ 
__p+='\n				<button data-position="'+
((__t=( key ))==null?'':_.escape(__t))+
'" class="js-choose">\n					'+
((__t=( key === 'bench' ? 'BENCH' : positions[key - 1].short_name ))==null?'':_.escape(__t))+
'\n				</button>\n			';
 }) 
__p+='\n		</div>\n	</footer>\n</div>';
}
return __p;
};
